import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@scio3/ui';

interface YouTubeDialogProps {
  url: string | null;
  onClose: () => void;
}

/**
 * Convert YouTube watch URL to embed URL
 * e.g. https://www.youtube.com/watch?v=abc123 -> https://www.youtube.com/embed/abc123?autoplay=1
 */
function getYoutubeEmbedUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get('v');
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }
  } catch {
    // If URL parsing fails, return original
  }
  return url;
}

/**
 * Simple YouTube video dialog that displays a video in a modal overlay.
 * Used by GetStartedDropdown to match scio1's fancybox behavior.
 */
export function YouTubeDialog({ url, onClose }: YouTubeDialogProps) {
  return (
    <Dialog open={!!url} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl pt-10" aria-describedby={undefined}>
        <DialogHeader className="sr-only">
          <DialogTitle>Tutorial video</DialogTitle>
        </DialogHeader>
        {url && (
          <iframe
            src={getYoutubeEmbedUrl(url)}
            className="aspect-video w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
